import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup,
    Export,
    HeaderFilter
  } from 'devextreme-react/data-grid';
  import React, { useState, useEffect } from 'react';
  import { useAuth } from '../../contexts/auth';
  import { Link, useNavigate } from 'react-router-dom';
  import TabPanel, { Item } from "devextreme-react/tab-panel";
  import axios from 'axios';
  import { backendlink } from '../../config';
  import { DoctorPatientChangepasswordForm } from '../../components';
  import PersonIcon from "../../svg/Property 1=person_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24 1.svg";


  export default function DoctorPatientChangepasswordPage() {
    const { user } = useAuth();
    const navigate = useNavigate();

    const [tabSelectedIndex, setTabSelectedIndex] = useState(0)

    function onTitleClick(e) {
        var itemIndex = e.itemIndex;
        var isReselected = false;

        if (itemIndex == tabSelectedIndex) {
            isReselected = true
        }

        setTabSelectedIndex(itemIndex)

        if (itemIndex == 0 && isReselected == true) {
            navigate('/doctor-patient?tabSelectedIndex=0');
        }
    }

    useEffect(() => {
        if (user.usertype == "Doctor") {

        } else {
            navigate('/');
        }
    }, []);

    return (
        <React.Fragment>
            <TabPanel className={'content-block dx-card responsive-paddings'} defaultSelectedIndex={0} swipeEnabled={false} scrollByContent={true} showNavButtons={true} onTitleClick={onTitleClick}>

                <Item title="Patient" icon={PersonIcon}> 
                    <DoctorPatientChangepasswordForm />
                </Item>
            </TabPanel>
        </React.Fragment>
    );
}